import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Add no-copy JS with tooltip
if (typeof window !== 'undefined') {
  let tooltipDiv = null;
  function showTooltip(msg, x, y) {
    if (tooltipDiv) {
      tooltipDiv.remove();
    }
    tooltipDiv = document.createElement('div');
    // Two lines, center-aligned, auto width, increased spacing between lines
    tooltipDiv.innerHTML = '<span style="display:inline-block;line-height:1.5;">Copying is disabled to protect proprietary content & prevent web crawlers.<br>If you would like to leverage any specific content, please contact me at hello@hyperhumane.com to discuss further & I\'ll be happy to share.</span>';
    tooltipDiv.style.position = 'fixed';
    // Center horizontally and position below header (assume header is 64px tall)
    tooltipDiv.style.left = '50%';
    tooltipDiv.style.top = (y !== undefined ? Math.max(y, 72) : 72) + 'px';
    tooltipDiv.style.transform = 'translateX(-50%)';
    tooltipDiv.style.background = 'rgba(60,0,120,0.95)';
    tooltipDiv.style.color = '#fff';
    tooltipDiv.style.padding = '12px 40px';
    tooltipDiv.style.borderRadius = '8px';
    tooltipDiv.style.zIndex = 9999;
    tooltipDiv.style.fontSize = '1rem';
    tooltipDiv.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
    tooltipDiv.style.textAlign = 'center';
    tooltipDiv.style.width = 'auto';
    document.body.appendChild(tooltipDiv);
    setTimeout(() => {
      if (tooltipDiv) tooltipDiv.remove();
      tooltipDiv = null;
    }, 4000); // 4 seconds
  }
  document.addEventListener('copy', function(e) {
    const el = document.activeElement;
    if (
      el.tagName !== 'INPUT' &&
      el.tagName !== 'TEXTAREA' &&
      !el.isContentEditable
    ) {
      e.preventDefault();
      showTooltip(
        'Copying is disabled to protect proprietary content & prevent web crawlers. If you would like to leverage any specific content, please contact me at hello@hyperhumane.com to discuss further & I\'ll be happy to share.',
        e.clientX,
        e.clientY
      );
    }
  });
  document.addEventListener('cut', function(e) {
    const el = document.activeElement;
    if (
      el.tagName !== 'INPUT' &&
      el.tagName !== 'TEXTAREA' &&
      !el.isContentEditable
    ) {
      e.preventDefault();
      showTooltip(
        'Copying is disabled to protect proprietary content & prevent web crawlers. If you would like to leverage any specific content, please contact me at hello@hyperhumane.com to discuss further & I\'ll be happy to share.',
        e.clientX,
        e.clientY
      );
    }
  });
} 